import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./frontend/navs/nav.routes').then((m) => m.routes),
  },
];
